<template>
    <div v-if="form.productLine">

        <section>
            <div class="container">

                <q-card class="q-mb-lg">
                    <q-card-section :class="{'q-px-xl' : screenSize.gt.sm, 'q-px-md' : screenSize.lt.md}">
                        <img :src="form.productLine.logo" class="img-tutorial q-mt-md q-mb-sm" :title="form.productLine.name" style="height: 55px;" />
                        <p>Choose your product for the latest download information.</p>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-4">
                                <q-select outlined dense class="q-mb-md"
                                          bg-color="white"
                                          label="Product Type" stack-label
                                          autocomplete="off"
                                          @input="$router.push(`/download/${form.productLine.name.toLowerCase()}`)"
                                          v-model="form.productLine" :options="productLines"
                                          option-label="name"
                                          hide-bottom-space />
                            </div>
                        </div>
                    </q-card-section>
                </q-card>

                <div v-if="form.productLine.name !== 'PlumbingCAD'" style="float: right;">
                    <q-btn flat color="primary" no-caps @click="archivedLink" class="row items-end col-xs-12 col-sm-auto">
                        <q-icon name="mdi-history" size="1.5em" class="q-mr-xs" /><span>Looking for an older version? Click here.</span>
                    </q-btn>
                </div>
                <div class="text-title">Latest {{ form.productLine.name }} Downloads</div>
                <p v-if="form.productLine.name == 'LoopCAD'">If you need a specific OEM version of LoopCAD, ensure to scroll down the page and download the desired LoopCAD edition.</p>

                <div>
                    <div v-if="genericDownload && genericDownload.length > 0">
                        <div class="text-subtitle">{{ genericDownload[0].version }}</div>
                        <p v-if="form.productLine.name == 'LoopCAD'">Generic {{ form.productLine.name }} only without OEM components or materials lists</p>
                        <q-card>
                            <q-list separator bordered class="rounded-borders bg-white">
                                <q-item v-for="download in genericDownload" :key="download.id"
                                        clickable
                                        class="row q-pa-md"
                                        :class="{'q-px-lg' : screenSize.gt.sm}"
                                        @click="showDownload(download)">
                                    <q-item-section v-if="getLogo(download.oemId)" avatar class="col-sm-4 col-md-3 gt-xs">
                                        <img :src="getLogo(download.oemId)" class="img-dl-logo" :title="download.oemId" />
                                    </q-item-section>

                                    <q-item-section top class="column items-start col-xs col-sm-2">
                                        <div class="text-left">
                                            <img v-if="getLogo(download.oemId)" :src="getLogo(download.oemId)" class="lt-sm img-dl-logo q-mb-xs" :title="download.oemId" />
                                            <q-item-label caption lines="1">
                                                <span>{{ download.fileSize }}</span>
                                            </q-item-label>
                                            <q-item-label caption lines="1">
                                                <span>{{ download.releaseDate | date }}</span>
                                            </q-item-label>
                                            <q-item-label caption lines="1">
                                                <span v-if="download.versionText">v{{ download.versionText }}</span>
                                            </q-item-label>
                                        </div>
                                    </q-item-section>

                                    <q-item-section top class="gt-xs col">
                                        <q-item-label class="text-weight-medium">
                                            {{ download.title }}
                                        </q-item-label>
                                        <q-item-label>
                                            {{ download.description }}
                                        </q-item-label>
                                    </q-item-section>

                                    <q-item-section side>
                                        <div>
                                            <q-btn flat dense icon="mdi-download" size="1.25em" color="primary" />
                                        </div>
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </q-card>
                    </div>
                    <div v-if="oemDownloads">
                        <div v-for="[key, value] in Object.entries(oemDownloads)" :key="key">
                            <div class="text-subtitle">{{ key }}</div>
                            <p v-if="form.productLine.name == 'LoopCAD'">Includes full {{ form.productLine.name }} program plus the OEM components and materials lists</p>
                            <q-card>
                                <q-list separator bordered class="rounded-borders bg-white">
                                    <q-item v-for="oemDownload in value" :key="oemDownload.id"
                                            @click="showDownload(oemDownload)"
                                            clickable class="row q-pa-md"
                                            :class="{'q-px-lg' : screenSize.gt.sm}">
                                        <q-item-section v-if="getLogo(oemDownload.oemId)" avatar class="col-sm-4 col-md-3 gt-xs">
                                            <img :src="getLogo(oemDownload.oemId)" class="img-dl-logo" :title="oemDownload.oemId" />
                                        </q-item-section>

                                        <q-item-section top class="column items-start col-xs col-sm-2">
                                            <div class="text-left">
                                                <img v-if="getLogo(oemDownload.oemId)" :src="getLogo(oemDownload.oemId)" class="lt-sm img-dl-logo q-mb-xs" :title="oemDownload.oemId" />
                                                <q-item-label caption lines="1">
                                                    <span>{{ oemDownload.fileSize }}</span>
                                                </q-item-label>
                                                <q-item-label caption lines="1">
                                                    <span>{{ oemDownload.releaseDate | date }}</span>
                                                </q-item-label>
                                                <q-item-label caption lines="1">
                                                    <span v-if="oemDownload.versionText">v{{ oemDownload.versionText }}</span>
                                                </q-item-label>
                                            </div>
                                        </q-item-section>

                                        <q-item-section top class="gt-xs col">
                                            <q-item-label class="text-weight-medium">
                                                {{ oemDownload.productCategoryID }} {{ oemDownload.title }}
                                            </q-item-label>
                                            <q-item-label>
                                                {{ oemDownload.description }}
                                            </q-item-label>
                                        </q-item-section>

                                        <q-item-section side>
                                            <div>
                                                <q-btn flat dense icon="mdi-download" size="1.25em" color="primary" />
                                            </div>
                                        </q-item-section>
                                    </q-item>
                                </q-list>
                            </q-card>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section v-if="additionalDownloads && additionalDownloads.length > 0">
            <div class="container">
                <div class="text-title">Additional Tools & Downloads</div>
                <q-card>
                    <q-list separator bordered class="rounded-borders">
                        <q-item clickable @click="downloadFile(dl.filePath)"
                                v-for="dl in additionalDownloads" :key="dl.id"
                                class="q-pa-md" :class="{'q-px-lg' : screenSize.gt.sm}">
                            <q-item-section top avatar class="col-sm-4 col-md-3 gt-xs">
                                <q-icon name="mdi-toolbox" size="2em" />
                            </q-item-section>

                            <q-item-section top class="column items-start col-sm-2">
                                <div class="text-left">
                                    <q-icon name="mdi-toolbox" size="2em" class="lt-sm q-mb-xs" />
                                    <q-item-label class="text-weight-medium lt-sm">
                                        {{ dl.title }}
                                    </q-item-label>
                                    <q-item-label caption lines="1">
                                        <span>{{ dl.fileSize }}</span>
                                    </q-item-label>
                                    <q-item-label caption lines="1">
                                        <span>{{ dl.releaseDate | date }}</span>
                                    </q-item-label>
                                    <q-item-label caption lines="1">
                                        <span>v{{ dl.versionText }}</span>
                                    </q-item-label>
                                </div>
                            </q-item-section>

                            <q-item-section top class="gt-xs col">
                                <q-item-label class="text-weight-medium">
                                    {{ dl.title }}
                                </q-item-label>
                                <q-item-label>
                                    {{ dl.description }}
                                </q-item-label>
                            </q-item-section>

                            <q-item-section side>
                                <div>
                                    <q-btn @click="downloadFile(dl.filePath)" flat dense icon="mdi-download" size="1.25em" color="primary" />
                                </div>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-card>
            </div>
        </section>
        <q-inner-loading :showing="pending">
            <div>
                <q-spinner color="primary"
                           :thickness="2"
                           size="3em" />
            </div>
        </q-inner-loading>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { productLines } from '@/plugins/productLines'

    export default {
        name: 'downloads',
        components: {

        },
        props: {
            productLine: String,
        },
        data() {
            return {
                allDownloads: [],
                productLines: Object.keys(productLines)?.map(key => {
                    return productLines[key]
                }),
                oems: [],
                form: {
                    productLine: null,
                }
            }
        },
        methods: {
            archivedLink() {
                this.$router.push(`/archived/download/${this.productLine}`)
            },
            showDownload(download) {
                if (download) {
                    this.$router.push('/download/' + this.productLine + '/' + download.oemId.toLowerCase())
                }

            },
            getLogo(id) {
                let oem = this.oems?.find(o => o.id == id)
                if (!oem?.logoPath) return ''
                return oem.logoPath
            },
            getOems() {
                this.oems = []
                this.$store.dispatch('getOEMs').then(() => {
                    this.oems = this.getOemsData
                    this.getDownloads()
                })

            },
            getDownloads() {
                this.allDownloads = []
                this.$store.dispatch('getDownloads').then(() => {
                    this.allDownloads = this.getDownloadsData?.filter(d => d.latestVersion)
                })
            },

            updateProductLine() {
                if (this.productLine)
                    this.form.productLine = this.productLines?.find(pl => pl.name.toLowerCase() == this.productLine.toLowerCase())
                else if (!this.form.productLine)
                    this.form.productLine = this.productLines[0]

                if (!this.form.productLine) this.$router.push('/download/loopcad')
            },
        },
        computed: {
            ...mapState([
                'getOemsPending',
                'getOemsData',
                'getDownloadsPending',
                'getDownloadsData',
            ]),
            additionalDownloads() {
                if (this.form.productLine?.name.toLowerCase() === 'loopcad' && this.allDownloads.length > 0) {
                    let downloads = this.allDownloads?.filter(d => d.oemId == 'UINS')
                    return downloads
                }
                return null
            },
            genericDownload() {
                if (this.form.productLine && this.allDownloads.length > 0) {
                    let downloads = this.allDownloads?.filter(d => d.productCategoryID == this.form.productLine?.name && d.oemId !== 'UINS' && !d.authorizeInfoToOEM)
                    return downloads.sort((a, b) => new Date(a.sortOrder) - new Date(b.sortOrder))
                }
                return null
            },
            oemDownloads() {
                if (this.form.productLine && this.allDownloads.length > 0) {
                    let downloads = this.allDownloads?.filter(d => d.productCategoryID == this.form.productLine?.name && d.oemId !== 'UINS' && d.authorizeInfoToOEM)
                    return downloads.sort((a, b) => new Date(a.sortOrder) - new Date(b.sortOrder)).reduce((result, currentValue) => {
                        (result[currentValue['version']] = result[currentValue['version']] || []).push(currentValue)
                        return result
                    }, {})
                }
                return null
            },
            pending() {
                return this.getOemsPending || this.getDownloadsPending
            },
            screenSize() {
                return this.$q.screen
            },

        },
        created() {
            this.getOems()
            this.updateProductLine()
        },
        watch: {
            productLine(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.updateProductLine()
                }
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    .img-logo {
        max-width: 100%;
        max-height: 55px;
        width: unset;
    }

    .img-oem-logo {
        max-width: 275px;
        max-height: 100%;
        height: unset;
    }

    .img-dl-logo {
        max-width: 100%;
        max-height: 40px;
        width: unset;
    }
</style>
